import { useState, useEffect } from 'react';

const useInterval = ({ INTERVAL_TIME }) => {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((s) => s + 1);
    }, INTERVAL_TIME);
    return () => {
      clearInterval(interval);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetTimer = () => setSeconds(0);

  return { seconds, resetTimer };
};

export default useInterval;
